export var Permissions;
(function (Permissions) {
    // 首頁
    Permissions[Permissions["HOME"] = 1025] = "HOME";
    // 會員
    Permissions[Permissions["USERS_PLAYERS"] = 1026] = "USERS_PLAYERS";
    // 管理層級
    Permissions[Permissions["USERS_AGENTS"] = 1027] = "USERS_AGENTS";
    // 子帳號
    Permissions[Permissions["USERS_SUB_ACCOUNT"] = 1041] = "USERS_SUB_ACCOUNT";
    // 最新優惠
    Permissions[Permissions["PROMOTE_ACTIVITIES"] = 1028] = "PROMOTE_ACTIVITIES";
    // 專屬網址
    Permissions[Permissions["PROMOTE_URL"] = 1036] = "PROMOTE_URL";
    // 佣金
    Permissions[Permissions["REPORT_COMMISSION"] = 1029] = "REPORT_COMMISSION";
    // 注單
    Permissions[Permissions["REPORT_BET"] = 1030] = "REPORT_BET";
    // 充提
    Permissions[Permissions["REPORT_TRANSACTION"] = 1031] = "REPORT_TRANSACTION";
    // 活動
    Permissions[Permissions["REPORT_ACTIVITY"] = 1032] = "REPORT_ACTIVITY";
    // 設置
    Permissions[Permissions["SETTING"] = 1037] = "SETTING";
    // 充值
    Permissions[Permissions["DEPOSIT"] = 1038] = "DEPOSIT";
    // 轉帳
    Permissions[Permissions["TRANSFER"] = 1039] = "TRANSFER";
    // 紀錄
    Permissions[Permissions["RECORD"] = 1040] = "RECORD";
    // 公告
    Permissions[Permissions["ANNOUNCEMENT"] = 1033] = "ANNOUNCEMENT";
    // 經銷公告
    Permissions[Permissions["AGENT_ANNOUNCEMENT"] = 1034] = "AGENT_ANNOUNCEMENT";
    // 經銷代存
    Permissions[Permissions["AGENT_DEPOSIT"] = 1035] = "AGENT_DEPOSIT";
    // 在線客服
    Permissions[Permissions["CS"] = 1042] = "CS";
})(Permissions || (Permissions = {}));
//# sourceMappingURL=Permissions.js.map